import { Children, ReactNode } from "react";

/**
 * Gets the number of child elements which are not null, undefined, false, or whitespace.
 * @param children The children to get the count for.
 * @returns The number of children which are not null, empty, or just whitespace.
 */
export function getNonEmptyChildCount(children: ReactNode): number {
  if (!children) return 0;

  let counter = 0;

  Children.forEach(children, (child) => {
    if (child === false) return;
    if (child === null) return;
    if (child === undefined) return;
    if (typeof child === "string" && child.trim() === "") return;

    counter++;
  });

  return counter;
}
